import { routesWithCaseIds as taskActionSubRoutes } from "../task/taskActions/routes";

export const routes = {
    "/clinicalHistory": {
        title: "Clinical history",
        ...taskActionSubRoutes
    }
};
